module.exports = __webpack_public_path__ + "static/prcat-34f335215ff9616ab6335b80d9733c88.svg";